import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes, faSitemap, faSun } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as IconeMapa } from '../icones/mapa.svg'
import { ReactComponent as IconeContraste } from '../icones/contraste.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { lazy, Suspense } from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import './App.scss'
import Breadcrumbs from './Breadcrumbs'
import Carregando from './Carregando'
import Controles from './Controles'
import ErrorBoundary from './ErrorBoundary'
import Menu from './Menu'
import OcultaFiltro from './OcultaFiltro'
import Pesquisar from './Pesquisar'
import Programas, { programas } from './Programas'
import Titulo from './Titulo'
import RodapeSite from './RodapeSite'
import { Link } from 'react-router-dom'

import moment from 'moment'

const Erro404 = lazy(() => import('./Erro404'))

let resultados = []

const mobileMaxWidth = 575

class App extends React.Component {
    constructor(props) {
        super(props)
        this.setResultadosPesquisa = this.setResultadosPesquisa.bind(this)
        this.state = { menuAberto: false }
        this.stateContraste = { altoContraste: false }
        this.state = { currentDateTime: this.formataData() }
        this.toggleMenu = this.toggleMenu.bind(this)
        this.resultados = []
        library.add(faBars)
        library.add(faTimes)
        library.add(faSun)
        library.add(faSitemap)
    }

    componentDidMount() {
        this.setState({ menuAberto: window.innerWidth <= mobileMaxWidth })
    }

    setResultadosPesquisa(res) {
        console.debug('RESULTADOS')
        console.debug(res)

        resultados = res

        this.setState({
            resultados: res,
        })
    }

    alternaContraste() {
        Promise.resolve(this.setState({ altoContraste: !this.state.altoContraste })).then(() => {
            this.atribuiContraste()
            this.salvaEstado()
        })
    }

    salvaEstado() {
        window.sessionStorage.setItem('preferencias', JSON.stringify(this.state))
    }

    atribuiContraste() {
        document.body.setAttribute('id', this.state.altoContraste ? 'contraste' : '')
    }

    toggleMenu(val = !this.state.menuAberto) {
        const portal = document.querySelector('.portal')

        this.setState({
            menuAberto: val,
        })

        this.setState({ currentDateTime: this.formataData() })

        portal.classList.remove('lockScroll')
    }

    toggleMenuMobile(val = !this.state.menuAberto) {
        const portal = document.querySelector('.portal')
        const menu = document.querySelector('#menu')
        const menuSlider = document.querySelector('.menuContainerOpcoes')

        this.setState({ currentDateTime: this.formataData() })

        if (menuSlider) {
            menuSlider.classList.remove('subMenuAberto')
        }

        let larguraTela = window.innerWidth

        if (larguraTela > mobileMaxWidth) {
            this.setState({
                menuAberto: val,
            })
        }

        if (!this.state.menuAberto) {
            this.setState({
                menuAberto: true,
            })
        } else {
            menu.classList.toggle('menuMobileAberto')
            portal.classList.toggle('lockScroll')
        }
    }

    formataData() {
        let dataAgora = moment()

        return dataAgora.format('dddd, DD MMMM YYYY, HH:mm:ss')
    }

    onKeyDownValue(event) {
        if (event.key === 'Enter') {
            this.toggleMenu()
        }
    }

    render() {
        console.debug('BEFORE RENDER')
        console.debug(this.state)

        return (
            <ErrorBoundary>
                <Router>
                    <div className="portal">
                        <Controles toggleMenu={this.toggleMenu} />
                        <header className="header">
                            <Titulo>
                                <span tabindex="0" onKeyDown={this.onKeyDownValue.bind(this)} className="ocultaFiltro">
                                    <FontAwesomeIcon
                                        onClick={() => this.toggleMenu()}
                                        className="iconeMenu"
                                        icon={this.state.menuAberto ? ['fas', 'times'] : ['fas', 'bars']}
                                        title="Menu"
                                    />
                                </span>

                                <OcultaFiltro />
                            </Titulo>
                            <div className="controlesMobile">
                                <Link to="/mapaDoSite">
                                    <IconeMapa className="iconeMapa" />
                                </Link>
                                <IconeContraste onClick={() => this.alternaContraste()} className="iconeContraste" size="2x" title="Contraste" />
                            </div>
                            <div className="navMobile">
                                <Pesquisar programas={programas} setResult={this.setResultadosPesquisa} />

                                <div className="menuFiltroIconeContainer">
                                    <span className="ocultaFiltro">
                                        <FontAwesomeIcon onClick={() => this.toggleMenuMobile()} className="iconeMenu" icon={['fas', 'bars']} title="Menu" />
                                    </span>

                                    <div className="separadorIcones"></div>

                                    <OcultaFiltro />
                                </div>
                            </div>
                        </header>
                        <main className="area-programa">
                            <Menu
                                toggleMenu={this.toggleMenu}
                                menuAberto={this.state.menuAberto}
                                currentDateTime={this.state.currentDateTime}
                                toggleMenuMobile={this.toggleMenuMobile.bind(this)}
                            />
                            <nav className="breadcrumb-bar">
                                <Breadcrumbs programas={programas} />
                            </nav>
                            <Suspense fallback={<Carregando />}>
                                <Switch>
                                    {/*<Home />*/}
                                    <Programas resultados={this.state.resultados} />
                                    <Route component={p => <Erro404 {...p} />} />
                                </Switch>
                            </Suspense>
                        </main>
                        <footer className="footer-main">
                            <RodapeSite />
                        </footer>
                    </div>
                </Router>
            </ErrorBoundary>
        )
    }
}

export default App
